import React, { useEffect, useState } from "react";
import { render } from 'react-dom';
import intl from 'react-intl-universal';
import { Button, Modal } from "antd";
import { InfoCircleOutlined, WarningOutlined } from "@ant-design/icons";

const CONTAINER_ID = 'fv_dd-modal__confirm';
let modelRootDOMCache = null;
function getContainer() {
    if (modelRootDOMCache) return modelRootDOMCache;
    const node = document.createElement('div');
    node.id = CONTAINER_ID;
    document.body.appendChild(node);
    modelRootDOMCache = node;
    return node;
}

export function confirmNoCancel() {
    return commonConfirmRender({
        title: "使用管理",
        content: "当前组织无可用的授权，请前往钉钉升级授权规格。",
        noCancel: true
    });
}

export function confirmBatchOps({
    subTitle,
    content,
    icon
}: {
    subTitle: string;
    content: string;
    icon?: "warning";
}) {
    return commonConfirmRender({
        title: '使用管理',
        subTitle,
        content,
        icon
    })
}

export function commonConfirmRender({
    title,
    subTitle,
    content,
    icon,
    noCancel,
    okText
}: {
    title?: string;
    subTitle?: string;
    content: string;
    icon?: "info" | "warning";
    noCancel?: boolean;
    okText?: string;
}) {
    return new Promise<boolean>((resolve) => {
        render(
            <NoSideEffectConfirm
                title={title}
                subTitle={subTitle}
                content={content}
                icon={icon}
                noCancel={noCancel}
                okText={okText}
                resolve={resolve}
            />,
            getContainer()
        );
    });
}

function NoSideEffectConfirm({
    title,
    subTitle,
    content,
    icon,
    noCancel,
    okText,
    resolve,
}: {
    title?: string;
    subTitle?: string;
    content: string;
    noCancel?: boolean;
    icon?: "info" | "warning";
    okText?: string;
    resolve: (value: boolean) => void;
}) {
    const [visible, setVisible] = useState(true);
    // `resolve` will be changed, when invoking render anew.
    // As `resolve` has changed, open modal by setVisible(true).
    useEffect(() => {
        setVisible(true);
    }, [resolve]);

    function cancel() {
        setVisible(false);
        resolve(false);
    }
    function ok() {
        setVisible(false);
        resolve(true);
    }
    const iconStyle = { marginRight: 10, fontSize: 22 };
    return (
        // @ts-ignore
        <Modal
            visible={visible}
            width={460}
            title={title || intl.get('PhantomPDF.Online.TitleWithOnline')}
            onCancel={cancel}
            onOk={ok}
            okText={okText}
            cancelText={'取消'}
            footer={noCancel ? <Button type="primary" onClick={ok}>{okText || '确认'}</Button> : undefined}
            zIndex={1111}
        >
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {icon && icon === 'warning' ?
                    <WarningOutlined style={{ ...iconStyle, color: '#F58220' }} />
                    : < InfoCircleOutlined style={{ ...iconStyle, color: '#4C87D8' }} />
                }
                <div>
                    {subTitle && <div style={{ fontSize: 16, color: '#131313', marginBottom: 4 }}>{subTitle}</div>}
                    <div>{content}</div>
                </div>
            </div>
        </Modal >
    )
}
